export default "//cdn.scentbird.com/assets/frontbird-site/images/sea-shore_13c524.jpg";